import { colors } from './colors';
import { muiTheme } from './muiTheme';
export const theme: any = {
  palette: {
    ...colors,
    mode: 'light',
    text: {
      primary: '#08160f',
      secondary: 'rgba(0, 0, 0, 0.4)',
    },
    background: {
      default: '#F9F6FF',
      paper: '#fff',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  ...muiTheme,
};
